<template>
  <div class="card mgt-20px">
    <header class="header-card" >
      <p>{{ $t('detailParution.information.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <div class="is-italic has-text-default">
            {{ $t('detailParution.information.code') }}
          </div>
          <div v-if="clickCode" class="has-text-weight-semibold">
            <router-link-blank
              :to="{
                name: 'c.presse.parution',
                params: { id: parution.id } }"
              :message="parution.code">
            </router-link-blank>
          </div>
          <div v-else class="has-text-weight-semibold">
            {{ parution.code }}
          </div>
        </div>
        <div class="column is-3">
          <div class="has-text-default is-italic">
            {{ $t('detailParution.information.nomParution') }}
          </div>
          <div class="has-text-weight-semibold">
            {{ parution.nomParution }}
          </div>
        </div>
        <div class="column is-3">
          <div class="is-italic has-text-default">
            {{ $t('detailParution.information.numParution') }}
          </div>
          <div class="has-text-weight-semibold">
            {{ parution.numParution }}
          </div>
        </div>
        <div class="column is-3">
          <div class="is-italic has-text-default">
            {{ $t('detailParution.information.dateEnvoiCF') }}
          </div>
          <div class="has-text-weight-semibold">
            {{ parution.dateEnvoiCF | formatDate }}
          </div>
        </div>
        <div class="column is-3">
          <div class="is-italic has-text-default">
            {{ $t('detailParution.information.dateEnvoiBAT') }}
          </div>
          <div class="has-text-weight-semibold">
            {{ parution.dateEnvoiBAT | formatDate }}
          </div>
        </div>
        <div class="column is-3">
          <div class="is-italic has-text-default">
            {{ $t('detailParution.information.dateRemiseEltTech') }}
          </div>
          <div class="has-text-weight-semibold">
            {{ parution.dateRemiseEltTech | formatDate }}
          </div>
        </div>
        <div class="column is-3">
          <div class="is-italic has-text-default">
            {{ $t('detailParution.information.dateParution') }}
          </div>
          <div class="has-text-weight-semibold">
            {{ parution.dateParution | formatDate }}
          </div>
        </div>
        <div class="column is-3">
          <div class="is-italic has-text-default">
            {{ $t('detailParution.information.produit') }}
          </div>
          <div v-if="produit" class="has-text-weight-semibold">
            <router-link-blank
              :to="{
                name: 'c.bodac.catalogue-detailPresse',
                params: { id: produit.id } }"
              :message="produit.reference + ' - ' + produit.libelle">
            </router-link-blank>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  name: 'ParutionDetailInformations',
  props: {
    parution: {
      type: Object,
      required: true,
    },
    produit: {
      type: Object,
    },
    clickCode: Boolean,
  },
  components: {
    routerLinkBlank,
  },
};
</script>
